import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const FooterContainer = styled.footer`
  background-color: #1a1a1a;
  color: #fff;
  padding: 3rem 5%;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 2rem;
`;

const FooterSection = styled.div`
  min-width: 200px;
`;

const LogoContainer = styled.div`
  margin-bottom: 1rem;
`;

const LogoImage = styled.img`
  height: 50px;
  width: auto;
`;

const FooterTitle = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 1rem;
  font-weight: 600;
`;

const FooterLink = styled(Link)`
  display: block;
  margin-bottom: 0.5rem;
  color: #b3b3b3;
  text-decoration: none;
  transition: color 0.2s;
  
  &:hover {
    color: white;
  }
`;

const Copyright = styled.div`
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #333;
  text-align: center;
  color: #b3b3b3;
  font-size: 0.9rem;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <LogoContainer>
            <LogoImage 
              src={`${process.env.PUBLIC_URL}/logo-dark-background.png`}
              alt="Roaring Bots Logo" 
            />
          </LogoContainer>
          <FooterLink as="a" href="mailto:info@roaringbots.com">info@roaringbots.com</FooterLink>
        </FooterSection>
        
        <FooterSection>
          <FooterTitle>Navigation</FooterTitle>
          <FooterLink to="/">Home</FooterLink>
          <FooterLink to="/about">About</FooterLink>
          <FooterLink to="/contact">Contact</FooterLink>
        </FooterSection>
      </FooterContent>
      
      <Copyright>
        &copy; {new Date().getFullYear()} Roaring Bots. All rights reserved.
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;